import { logger } from '@/utils/logger';
import { AuthPage } from '@/components/auth/AuthPage';
import appServices from '@/services/appServices';
import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router';

export const Route = createFileRoute('/auth/signin')({
  component: RouteComponent,
  beforeLoad: () => {
    logger.debug('/auth/signin beforeLoad check');

    // Only redirect if user is already authenticated when landing on this page
    // This prevents redirect loops during the authentication process
    if (!appServices.auth.isInitialized) {
      logger.debug('Auth service not initialized yet, waiting...');
      return;
    }

    if (appServices.auth.isAuthenticated()) {
      const userSettings = appServices.auth.getUserSettings();
      logger.debug('User already authenticated, userSettings:', userSettings);

      if (userSettings?.onboarding_completed === 'true') {
        logger.debug('Redirecting to /dashboard (onboarding completed)');
        throw redirect({ to: '/dashboard' });
      } else {
        logger.debug('Redirecting to /onboarding (onboarding not completed)');
        throw redirect({ to: '/onboarding' });
      }
    }

    logger.debug('Not authenticated, showing signin page');
  },
});

function RouteComponent() {
  const navigate = useNavigate();

  return (
    <AuthPage
      mode='login'
      onBack={() => {
        navigate({ to: '/' });
      }}
    />
  );
}
